import { useState } from 'react';
import Navbar from '../components/Navbar';
import { Col, Container, Row } from 'react-bootstrap';
import axios from 'axios';
import Table from 'react-bootstrap/Table';
import '../Global.css';
import api from '../api';
function Search() {
    const [text, setText] = useState("");
    const [singerList, setSingerList] = useState(null);

    const handleChange = async (e) => {
        try {
            setText(e.target.value)
            console.log("text:", text);
            if (text === "") return;
            const data = await api.get(`/v1/music/searchArtist/${text}`);

            console.log(data.data.data);

            setSingerList(data.data.data);

        } catch (err) {
            console.log(err);
        }


    }

    return (
        <div className='app-container'>
            <Navbar />
            <div className='main-content'>

                <input placeholder='sanatçı arayın..' className='form-check' value={text} onChange={(e) => handleChange(e)} />

                <Table striped bordered hover variant='dark'>
                    <thead>
                        <tr>

                            <th>Resim</th>
                            <th>İsim</th>

                        </tr>
                    </thead>
                    <tbody>
                        {singerList !== null ? singerList.map((i) => {


                            return (
                                <tr>

                                    <td><a href={`/play?id=${i.id}&type=top-artist`} ><img src={i.picture_medium} /></a></td>
                                    <td>{i.name}</td>

                                </tr>
                            )
                        }) : null}

                    </tbody>
                </Table>
            </div>

        </div>

    )
}

export default Search;